import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';

import ContentRequestAssignmentTable from '../content-requests/ContentRequestAssignmentTable';
import AuthoredContentTable from './AuthoredContentTable';
import ContentRequestsTable from './ContentRequestsTable';
import SharedContentTable from './SharedContentTable';

const AuthorContent = () => {
  const appContext = useContext(AppContext);
  // @ts-expect-error TS2339 - strict migration
  const { userProfile } = appContext.authnInfo;

  return (
    <div>
      <ContentRequestAssignmentTable
        wrapperPadding={{ bottom: 'xxl', top: 'l' }}
        userProfile={userProfile}
      />
      <AuthoredContentTable wrapperPadding={{ bottom: 'xxl' }} userProfile={userProfile} />
      <SharedContentTable wrapperPadding={{ bottom: 'xxl' }} userProfile={userProfile} />
      <ContentRequestsTable wrapperPadding={{ bottom: 'xxl' }} userProfile={userProfile} />
    </div>
  );
};

export default AuthorContent;
